export var VERSION = '2.11.12';